import React from 'react';
import renderHTML from 'react-render-html';
import { MediaKitWrapper } from '../styles/mediaKit.style';
import { getViewport, generateImageUrl } from '../../../utils/webp';
import { RTE } from '../../../utils/atoms';

/**
 * Media Kit Component
 */
class MediaKit extends React.Component {
  /**
   * constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 2400,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Render component
   * @returns {JSX} Component JSX
   */
  render() {
    const {
      titleImage,
      titleImageAltText,
      subtitle,
      childContentfulMediaKitDescriptionTextNode,
      firstKitDownload,
      firstKitDownloadText,
      secondKitDownload,
      secondKitDownloadText,
      backgroundImage,
    } = this.props;
    const { viewportWidth } = this.state;
    const bkgd = backgroundImage && backgroundImage.file && backgroundImage.file.url;
    return (
      <MediaKitWrapper backgroundImage={generateImageUrl(bkgd, viewportWidth)}>
        <div className="xfl-media-kit__content">
          {titleImage
            && titleImage.file && (
            <img className="xfl-media-kit__title-image" src={titleImage.file.url} alt={titleImageAltText} />
          )}
          <h4 className="xfl-media-kit__subtitle">{subtitle}</h4>
          {childContentfulMediaKitDescriptionTextNode
            && childContentfulMediaKitDescriptionTextNode.childMarkdownRemark && (
            <RTE className="xfl-media-kit__description">
              {renderHTML(childContentfulMediaKitDescriptionTextNode.childMarkdownRemark.html)}
            </RTE>
          )}

          <div className="xfl-media-kit__download-wrapper">
            {firstKitDownload
              && firstKitDownload.file && (
              <a
                rel="noopener noreferrer"
                target="_blank"
                className="xfl-media-kit__download"
                href={firstKitDownload.file.url}
                download
              >
                <img
                  alt="PDF Icon"
                  src={
                    firstKitDownload.file.fileName.indexOf('.pdf') > -1
                      ? '/images/pdf-icon.png'
                      : '/images/jpg-icon.png'
                  }
                />
                {firstKitDownloadText}
              </a>
            )}
            {secondKitDownload
              && secondKitDownload.file && (
              <a
                rel="noopener noreferrer"
                target="_blank"
                className="xfl-media-kit__download"
                href={secondKitDownload.file.url}
                download
              >
                <img
                  alt="PDF Icon"
                  src={
                    secondKitDownload.file.fileName.indexOf('.pdf') > -1
                      ? '/images/pdf-icon.png'
                      : '/images/jpg-icon.png'
                  }
                />
                {secondKitDownloadText}
              </a>
            )}
          </div>
        </div>
      </MediaKitWrapper>
    );
  }
}

export default MediaKit;



// WEBPACK FOOTER //
// ./src/components/media-kit/components/mediaKit.js